import script from "./FormGalleryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGalleryComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormGalleryComponent.vue?vue&type=style&index=0&id=4d253b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d253b1e"]])

export default __exports__